import {createAsyncThunk} from '@reduxjs/toolkit';

import {selectEntityDataFormInstance, selectFormEntityData} from 'modules/data/data-selectors';
import {TAppState} from 'store/config/types';
import {WARNING_SLICE} from 'store/slices/warning-slice/model/constants';

import {isFormDirty} from '../lib/utils';
import {setWarningVisibility} from './slice';
import {IResolveModalDirtinessArgs} from './types';

export const resolveModalDirtiness = createAsyncThunk<void, IResolveModalDirtinessArgs>(
    `${WARNING_SLICE}/resolveModalDirtiness`,
    async (args, {dispatch, getState}) => {
        const {entityName, metadata, onClose} = args;
        const state = getState() as TAppState;
        const initialData = selectFormEntityData(entityName)(state)?.data;
        const form = selectEntityDataFormInstance(entityName)(state);

        if (form && 'getFieldsValue' in form && isFormDirty(entityName, form.getFieldsValue(), initialData, metadata)) {
            dispatch(setWarningVisibility({entityName, warningVisible: true}));
        } else {
            dispatch(setWarningVisibility({entityName, warningVisible: false}));
            onClose();
        }
    },
);
